import ApiService from "../../../ceres/services/ApiService";
import { isDefined } from "../../../ceres/helper/utils";

const state = () => ({
	categoryItemSiblings: {},
	categoryItemSiblingsIsLoading: false,
	categoryItemSiblingsIsDirty: false,
	categoryItemData: {}
});

const mutations = {
	setCategoryItemSiblings(state, categoryItemSiblings) {
		state.categoryItemSiblings = categoryItemSiblings;
	},

	pushCategoryItemSibling(state, categoryItemSibling) {
		const categoryItemSiblingKey = parseInt(Object.keys(categoryItemSibling)[0]);

		state.categoryItemSiblings[categoryItemSiblingKey] = categoryItemSibling[categoryItemSiblingKey];
	},

	setCategoryItemData(state, categoryItemData) {
		state.categoryItemData = categoryItemData;
	},

	setIsCatItemSiblingsLoading(state, isLoading) {
		state.categoryItemSiblingsIsLoading = isLoading;
		state.categoryItemSiblingsIsDirty = true;
	}
};

const actions = {
	pushCategoryItemSiblings({ commit }, variationData) {
		commit("setCategoryItemData", {
			itemIds: Object.keys(variationData),
			excludedVariationIds: Object.values(variationData)
		});
	},
	getCategoryItemSiblings({ commit, rootGetters, state }, { overwriteUrl, imageOptions, urlAccessor }) {
		if (!state.isCatItemSiblingsLoading && Object.keys(state.categoryItemData).length > 0) {
			return new Promise((resolve, reject) => {
				let excludedVariationIds = "";

				let variationIdsToInclude = "";

				const facets = rootGetters.selectedFacetIdsForUrl.toString();
				const params = {
					itemIds: state.categoryItemData.itemIds.join(","),
					overwriteUrl,
					imageOptions,
					urlAccessor,
					cutoff: (App.Eros.Config.itemlists.categoryItemSiblingsLimit + (App.Eros.Config.itemlists.categoryItemSiblingsShowSelf ? 1 : 0))
				};

				if (!App.Eros.Config.itemlists.categoryItemSiblingsShowSelf) {
					excludedVariationIds = state.categoryItemData.excludedVariationIds.join(",");
					if (excludedVariationIds.length > 0) {
						params.excludedVariationIds = excludedVariationIds;
					}
				} else {
					variationIdsToInclude = state.categoryItemData.excludedVariationIds.join(",");
					if (variationIdsToInclude.length > 0) {
						params.variationIdsToInclude = variationIdsToInclude;
					}
				}

				if (App.Eros.Config.itemlists.categoryItemSiblingsEnableFacetFilter && facets.length > 0) {
					params.facets = facets;
					params.facetsType = App.Eros.Config.itemlists.categoryItemSiblingsFacetsType;
				}

				commit("setIsCatItemSiblingsLoading", true);

				ApiService.get("/rest/rYkuVd3VFCff3LzF", params, { keepOriginalResponse: true })
					.done(response => {
						if (isDefined(response.data)) {
							commit("setCategoryItemSiblings", response.data.childList);
							commit("setIsCatItemSiblingsLoading", false);
							resolve(response.data.documents);
						} else {
							resolve(null);
						}
					})
					.fail(error => {
						commit("setIsCatItemSiblingsLoading", false);
						reject(error);
					});
			});
		}

		return null;
	}
};

const getters = {
	getCategoryItemDataCount: state => () => {
		return Object.keys(state.categoryItemData).length;
	}
};

export default {
	state,
	actions,
	mutations,
	getters
};
